import { gql } from "@apollo/client";

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_PRODUCT_PRICE = gql`
  mutation updateProductPrice(
    $where: ProductPriceUpdateWhereInput
    $data: ProductPriceUpdateDataInput
  ) {
    productPriceUpdateResponse: updateProductPrice(where: $where, data: $data) {
      id
    }
  }
`;
